import { Button } from 'components/Button/Button';

type Props = {
  saved: boolean;
  onSave: () => Promise<void>;
  onUnsave: () => Promise<void>;
};

export function SaveOrgMenuItem({ saved, onSave, onUnsave }: Props) {
  return (
    <Button
      onClick={() => {
        if (saved) void onUnsave();
        else void onSave();
      }}
      data-qa-id={`${saved ? 'unsave' : 'save'}-org`}
      variant="link-grey"
      iconPosition="left"
      icon={{ type: 'normalized', name: 'star-outline' }}
      size="small"
      type="button"
    >
      {saved ? getText('Unsave Organization') : getText('Save Organization')}
    </Button>
  );
}
